<template>
  <div class="pr-1 pl-1">
    <div class="no-gutters mt-1 mb-2 ml-3 mr-3">
      <div class="row">
          <div class="col-9">
            <div class="parameter-box">
              <h4>{{ position }}</h4>
              <div class="parameter-name">Current position</div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Helpers from '../../../mixins/helpers'

export default {
  name: 'ShipMarineTrafficDashboardWidget',
  mixins: [
    Helpers
  ],
  data: function () {
    return {}
  },
  props: ['platformId'],
  computed: {
    ...mapState(['platforms']),
    ...mapGetters(['currentUpdate', 'lastUpdate']),
    position () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude, 2),
        this.roundDigits(this.longitude, 2), 2)
      return position.lat + ' ' + position.lng
    },
    latitude () {
      const update = this.currentUpdate(this.platformId, 1, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    longitude () {
      const update = this.currentUpdate(this.platformId, 1, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    heading () {
      const update = this.currentUpdate(this.platformId, 1, 3)
      return (update.length !== 0) ? Number(update[1]) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .parameter-box {
    padding: 10px 10px 5px 10px;
  }
  .parameter-box h4 {
    margin-bottom: 2px;
  }
  .parameter-box h5 {
    margin-bottom: 2px;
  }
  .parameter-name {
    font-size: 11px;
    color: #6c757d;
  }
  .state-box {
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    vertical-align: bottom;
    border-radius: 2px;
    padding: 5px 2px 5px 2px;
  }
  .state-ok {
    background-color: #82E0AA;
    color: #186A3B;
  }
  .state-danger {
    background-color: #F1948A;
    color: #78281F;
  }
  .no-gutters {
    margin-right: 10px;
    margin-left: 10px;
    .col,
    [class*="col-"] {
      padding-right: 2px;
      padding-left: 2px;
    }
  }
</style>
